import * as React from 'react';
// Import react.
import { useParams } from "react-router-dom";
// Import props.
import {
	MortgageeProps,
} from '@app/props';
// Import hooks.
import {
	useAppRedirect,
} from '@app/hooks/utility';

interface UseMortgageePropsFromRouterResult extends MortgageeProps {

}

interface UseMortgageePropsFromRouterParameters {
	useSectionKeyAsMortgageeGuid: boolean;
}

const useMortgageePropsFromRouter = (params?: UseMortgageePropsFromRouterParameters): UseMortgageePropsFromRouterResult => {
	const useSectionKeyAsMortgageeGuid: boolean = params?.useSectionKeyAsMortgageeGuid ?? false;
	const { redirect } = useAppRedirect();
	const routeParams = useParams();

	// Parse out the router parameters for mortgagee guid.
	const mortgageeGuid: string | undefined = React.useMemo(() => {
		return useSectionKeyAsMortgageeGuid ? routeParams['sectionKey'] : routeParams['mortgageeGuid'];
	}, [routeParams]);

	React.useEffect(() => {
		if (mortgageeGuid === undefined) {
			redirect();
		}
	}, [mortgageeGuid]);

	return {
		mortgageeGuid: mortgageeGuid ?? String.empty(),
	};
}

// Export results.
export {
	UseMortgageePropsFromRouterResult,
}

// Export parameters.
export {
	UseMortgageePropsFromRouterParameters,
}

export default useMortgageePropsFromRouter;